export const track = (name, params = {}) => {
  try {
    if (typeof window.gtag === "function") window.gtag("event", name, params);
  } catch (e) { /* analytics must never break the UI */ }
};
